__webpack_require__.p = "/Figma-to-code-challenge-NTF-Service/";